import "../scss/style.scss";
import objectFitImages from 'object-fit-images';
import MatchHeight from 'matchheight';
import "./home.js";


jQuery(function ($) {

//スムーススクロール
$(function(){
	var headerHeight = $('#header').outerHeight();
	var urlHash = location.hash;
	if (urlHash) {
		$('body,html').stop().scrollTop(0);
		setTimeout(function () {
			var target = $(urlHash);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({
				scrollTop: position
			}, 500);
		}, 100);
	}
	$('a[href^="#"]').click(function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? "body" : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, 500, "swing");
		return false;
	});
});

//スクロールされたらフェードイン & アップ
$(window).on('load scroll', function() {
	$('.fade-in, .fade-up').each(function(){
		var elemPos = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll > elemPos - windowHeight + windowHeight/7){
			$(this).addClass('scrollin');
		}
		else {
			$(this).removeClass('scrollin');
		}
	});
});

//【SP】SP版メニュー　クリックイベント
$(document).ready(function(){
	$('.navBtn').on('click',function(){
		if($('#nav').css('display') == 'none'){
			$("#nav").fadeIn(200);
			$(".navBtn .txt").text('CLOSE');
			$(this).addClass('close');
		} else {
			$("#nav").fadeOut(200);
			$(".navBtn .txt").text('MENU');
			$(this).removeClass('close');
     }
	});
	if (window.matchMedia('(max-width:768px)').matches) {
		$('.navBtn.close,#nav').on('click', function () {
			$("#nav").fadeOut(200);
			$('.navBtn.close').removeClass('close');
			$(".navBtn .txt").text('MENU');
		});
	}
});

// object-fit
$(function () {
	objectFitImages('.imgFitBox img,.imgLinkBox img,.imgMv');
});

// スマホ高さ100vh調整
window.addEventListener('load', () => {
  // let vh = window.innerHeight * 0.01;
  let vh = document.documentElement.clientHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
});

// サイドナビ固定
$(window).on('load scroll resize', function () {
	if (window.matchMedia('(min-width:769px)').matches) {
		var sideBanner = $('.sideBanner');
		var scroll = $(window).scrollTop();
		var fixH = $(window).height();
		if (scroll > fixH) {
			sideBanner.addClass('fixed');
		} else {
			sideBanner.removeClass('fixed');
		}
	}
});

$(window).on('load resize', function() {
  if (window.matchMedia('(min-width:768px)').matches) {
    //ドロップダウン PC
    $('#header .list .item.dropdwn').hover(function() {
      $(this).find('.dropdwn_menu').toggleClass('open');
    });
  }
});

$(window).on('load scroll', function() {
	if (window.matchMedia('(max-width:768px)').matches) {
    var scroll = $(window).scrollTop();
    if (scroll > 60) {
      $('.spBottomBannerBox').fadeIn();
    } else {
      $('.spBottomBannerBox').fadeOut();
    }
  }
});

$(function() {
  if ($('.magnific_popup').length) {
		$('.magnific_popup').magnificPopup({
			type: 'inline',
			closeBtnInside: true,
			closeOnBgClick: true,
			fixedContentPos: true,
			showCloseBtn: true,
		});
	}
});

$(function() {
  /* ページ読み込み時のボタン制御処理 */
  if ($('input[id="agree-1"]:checked').val()) {
    $('[name="submitConfirm"]').prop("disabled", false);
  } else {
    $('[name="submitConfirm"]').prop("disabled", true);
  }

  /* 同意のチェックボックスをクリックした際のボタン制御処理 */
  $('[id="agree-1"]').click(function() {
    if ($('input[id="agree-1"]:checked').val()) {
      $('[name="submitConfirm"]').prop("disabled", false);
    } else {
      $('[name="submitConfirm"]').prop("disabled", true);
    }
  });

  /**
   * 確認画面用（確認画面のボタンは常に押せる状態にしておく）
   * ※この書き方は苦肉の策感がすごいする・・・
   */
  if (location.pathname === '/confirmation/') {
    $('[name="submitButton"]').prop("disabled", false);
  }
});

});
